<template>
  <div :style="pathStructureStyle">
    <div class="box-head">Allosteric pathways</div>
    <div class="box-tool">
      <a :href="$store.state.host + `/dokhlab/actions/ohm/result?id=${task.id}&file=path-pse`">{{task.id}}-path.pse</a> <a v-if="structureReady" @click="$refs.ngl.screenShot()" style="cursor:pointer">structure.png</a>
    </div>
    <div v-if="!showStructure">
      <el-button type="text" @click.native="viewStructure">View 3D structures</el-button>
    </div>
    <div v-show="showStructure" v-loading="showStructure&&!structureReady">
      <ngl-view class="ngl-view" ref="ngl" :height="600" :nameWidth="200"></ngl-view>
    </div>
  </div>
</template>

<script>
import interpolate from 'color-interpolate'
import { saveAs } from 'file-saver'
import NglView from './NglView/NglView.vue'
import * as NGL from 'ngl'

export default {
  name: 'Paths',

  data () {
    return {
      showStructure: false,
      structureReady: false,
      active_site: [],
      allosteric_site: [],
      pathStructureStyle: {
        width: '100%',
//        border: '1px solid #eeeeee',
        margin: '20px 0px',
        position: 'relative',
        '-webkit-user-select': 'none',
        '-moz-user-select': 'none',
        '-khtml-user-select': 'none',
        '-ms-user-select': 'none'
      },
      paths: {}
    }
  },

  props: [ 'value' ],

  components: {
    NglView
  },

  computed: {
    task () {
      return this.$store.state.task
    }
  },

  methods: {
    viewStructure () {
      this.showStructure = true
      this.$nextTick(() => {
        this.checkTask()
      })
    },

    download () {
      this.cyPromise.then(cy => {
        saveAs(cy.png({'output': 'blob'}), 'nodes.png')
      })
    },

    redirect (url) {
      window.location.href = url
    },

    openNewTab (url) {
      window.open(url, '_blank')
    },

    getIndByNum (num) {
      return this.task.results.ind.find(i => i.num === num)
    },

    getInd (chainName, resNum) {
      return this.task.results.ind.find(i => i.name === `${chainName}/${resNum}`)
    },

    getSites (sites) {
      let vec = []
      let ls = sites.trim().split(/,/)
      for (let s of ls) {
        let w = s.split(/\//)
        let chainName = w[0]
        let residues = w[1]
        let v = residues.split(/\+/)
        for (let i of v) {
          let u = i.split(/-/)
          if (u.length === 2) {
            let a = parseInt(u[0])
            let b = parseInt(u[1])
            for (let j = a; j <= b; j++) {
              vec.push(this.getInd(chainName, j).num)
            }
          } else if (u.length === 1) {
            vec.push(this.getInd(chainName, u[0]).num)
          }
        }
      }
      return vec
    },

    setSites () {
      let v = this
      v.active_site = v.getSites(v.task.par.active_site)
      v.allosteric_site = v.getSites(v.task.par.allosteric_site)
    },

    getPaths () {
      let v = this
      let paths = {}
      for (let path of v.task.results.paths) {
        let id = path.path.join('-')
//        let id = path.path.filter(i => {
//          let j = parseInt(i)
//          return !(v.active_site.includes(j)) && !(v.allosteric_site.includes(j))
//        }).join('-')
        if (!(id in paths)) {
          paths[id] = {
            weight: 0.0
          }
        }
        paths[id].weight += path.weight
      }

      let maxWeight = 0.0
      for (let id in paths) {
        paths[id].name = `${id.split(/-/).map(i => v.task.results.ind.find(j => j.num === parseInt(i)).name).join(' - ')}`
//        paths[id].name = `Start - ${id.split(/-/).map(i => v.task.results.ind.find(j => j.num === parseInt(i)).name).join(' - ')} - End`
        if (maxWeight < paths[id].weight) {
          maxWeight = paths[id].weight
        }
      }
      for (let id in paths) {
        paths[id].normWeight = paths[id].weight / maxWeight
      }

      return paths
    },

    checkTask () {
      let v = this
      let task = this.task

      if (task) {
        v.setSites()
        v.paths = v.getPaths()

        let colormap = interpolate(['#053795', 'green', 'yellow', '#900c3f'])
        v.$refs.ngl.load(new Blob([v.task.par.structure_data], {type: 'text/plain'}), { ext: v.task.par.structure_type }).then(obj => {
//          console.log(obj)
          obj.setColor('white')
          let startStr = v.active_site.map(i => `${v.getIndByNum(i).residue}:${v.getIndByNum(i).chain}`).join(' or ')
          let endStr = v.allosteric_site.map(i => `${v.getIndByNum(i).residue}:${v.getIndByNum(i).chain}`).join(' or ')
          let n = 0
          for (let id in v.paths) {
            let path = v.paths[id]
            let ls = id.split(/-/).map(i => {
              let ind = v.getIndByNum(parseInt(i))
              return `${ind.residue}:${ind.chain}`
            })
            let pathStr = ls.join(' or ')
            let o = v.$refs.ngl.store.addObject(path.name, 'selection', obj.components, [new NGL.Selection(`${startStr} or ${pathStr} or ${endStr}`)])
            o.showLabel('residue')
            n += 1
            if (n === 20) break
          }
        })

        let ids = Object.keys(v.paths)
        ids.sort((a, b) => v.paths[b].weight - v.paths[a].weight)

        let data = []
        let labels = []
        let colors = []
        for (let id of ids) {
          data.push(v.paths[id].weight)
          labels.push(v.paths[id].name)
          colors.push(colormap(v.paths[id].normWeight))
        }

        this.structureReady = true
      } else {
        setTimeout(() => {
          v.checkTask()
        }, 500)
      }
    }
  },

  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.ngl-view {
  /*
  box-shadow: 0 0 5px #888888;
  border: 1px solid #eeeeee;
  margin: 20px 0px;
  */
}

.box-head {
  padding: 10px;
  border-bottom: 1px solid #eeeeee;
  background-color: $theme-color;
  font-weight: 700;
  color: white;
}

.box-tool {
  padding:10px 0px;
}


</style>
